import axios from "axios";
import setAuthToken from "../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import {
  GET_ERRORS,
  SET_CURRENT_USER,
  USER_LOADING,
  FETCHING_DATA_SUCCESS,
} from "./types";

var key = process.env.REACT_APP_KEY2;

function build_HistoricSingleURL(symbol) {
  const URL = `https://query2.finance.yahoo.com/v8/finance/chart/${symbol}?symbol=${symbol}&period1=0&period2=9999999999&interval=1mo`;
  return URL;
}
function build_HistoricDailySingleURL(symbol) {
  const URL = `https://query2.finance.yahoo.com/v8/finance/chart/${symbol}?symbol=${symbol}&period1=0&period2=9999999999&interval=1d`;
  return URL;
}

function build_FinanceSingleURL(symbol) {
  const URL = `https://query1.finance.yahoo.com/v10/finance/quoteSummary/${symbol}?modules=assetProfile%2CincomeStatementHistory%2CincomeStatementHistoryQuarterly%2CbalanceSheetHistory%2CbalanceSheetHistoryQuarterly%2CcashflowStatementHistory%2CcashflowStatementHistoryQuarterly%2CdefaultKeyStatistics%2CfinancialData%2CcalendarEvents%2CsecFilings%2CrecommendationTrend%2CupgradeDowngradeHistory%2CinstitutionOwnership%2CfundOwnership%2CmajorDirectHolders%2CmajorHoldersBreakdown%2CinsiderTransactions%2CinsiderHolders%2CnetSharePurchaseActivity%2Cearnings%2CearningsHistory%2CearningsTrend%2CindustryTrend%2CindexTrend%2CsectorTrend`;
  return URL;
}

// Register User
export const registerUser = (userData, history) => (dispatch) => {
  axios
    // .post("http://localhost:3005/api/users/register", userData)
    .post("https://trend-backend.herokuapp.com/api/users/register", userData)
    .then((res) => {}) // re-direct to login on successful register
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};
// Login - get user token
export const loginUser = (userData) => (dispatch) => {
  axios
    // .post("http://localhost:3005/api/users/login", userData)
    .post("https://trend-backend.herokuapp.com/api/users/login", userData)
    .then((res) => {
      const { token } = res.data;
      localStorage.setItem("jwtToken", token);
      setAuthToken(token);
      const decoded = jwt_decode(token);
      dispatch(setCurrentUser(decoded));
    })
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Set logged in user
export const setCurrentUser = (decoded) => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded,
  };
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING,
  };
};

// Log user out
export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("jwtToken");
  setAuthToken(false);
  dispatch(setCurrentUser({}));
};

// fetch api data

export const fetchSingleStock = (sym) => {
  var dataURL = build_FinanceSingleURL(sym);
  var historicURL = build_HistoricSingleURL(sym);
  var historicDailyURL = build_HistoricDailySingleURL(sym);
  var data = {
    dataURL: `${dataURL}`,
    historicURL: `${historicURL}`,
    historicDailyURL: `${historicDailyURL}`,
  };
  return function (dispatch) {
    axios
      // .post("http://localhost:3005/api/stocks/", data)
      .post("https://trend-backend.herokuapp.com/api/stocks/", data)
      .then((res) => {
        if (res.data.name == "Error") {
          console.log(res.data.message, " - Cannot locate stock data");
        } else {
          let financialData = res.data[0].quoteSummary.result[0].financialData;
          let assetProfile = res.data[0].quoteSummary.result[0].assetProfile;
          let incomeStatementHistory =
            res.data[0].quoteSummary.result[0].incomeStatementHistory;
          let incomeStatementHistoryQuarterly =
            res.data[0].quoteSummary.result[0].incomeStatementHistoryQuarterly;
          let balanceSheetHistory =
            res.data[0].quoteSummary.result[0].balanceSheetHistory;
          let balanceSheetHistoryQuarterly =
            res.data[0].quoteSummary.result[0].balanceSheetHistoryQuarterly;
          let cashflowStatementHistory =
            res.data[0].quoteSummary.result[0].cashflowStatementHistory;
          let cashflowStatementHistoryQuarterly =
            res.data[0].quoteSummary.result[0]
              .cashflowStatementHistoryQuarterly;
          let defaultKeyStatistics =
            res.data[0].quoteSummary.result[0].defaultKeyStatistics;
          let calendarEvents =
            res.data[0].quoteSummary.result[0].calendarEvents;
          let secFilings = res.data[0].quoteSummary.result[0].secFilings;
          let recommendationTrend =
            res.data[0].quoteSummary.result[0].recommendationTrend;
          let upgradeDowngradeHistory =
            res.data[0].quoteSummary.result[0].upgradeDowngradeHistory;
          let institutionOwnership =
            res.data[0].quoteSummary.result[0].institutionOwnership;
          let fundOwnership = res.data[0].quoteSummary.result[0].fundOwnership;
          let majorDirectHolders =
            res.data[0].quoteSummary.result[0].majorDirectHolders;
          let majorHoldersBreakdown =
            res.data[0].quoteSummary.result[0].majorHoldersBreakdown;
          let insiderTransactions =
            res.data[0].quoteSummary.result[0].insiderTransactions;
          let insiderHolders =
            res.data[0].quoteSummary.result[0].insiderHolders;
          let netSharePurchaseActivity =
            res.data[0].quoteSummary.result[0].netSharePurchaseActivity;
          let earnings = res.data[0].quoteSummary.result[0].earnings;
          let earningsHistory =
            res.data[0].quoteSummary.result[0].earningsHistory;
          let earningsTrend = res.data[0].quoteSummary.result[0].earningsTrend;
          let industryTrend = res.data[0].quoteSummary.result[0].industryTrend;
          let indexTrend = res.data[0].quoteSummary.result[0].indexTrend;
          let sectorTrend = res.data[0].quoteSummary.result[0].sectorTrend;

          let data = [];
          data = {
            apiData: [
              financialData,
              assetProfile,
              incomeStatementHistory,
              incomeStatementHistoryQuarterly,
              balanceSheetHistory,
              balanceSheetHistoryQuarterly,
              cashflowStatementHistory,
              cashflowStatementHistoryQuarterly,
              defaultKeyStatistics,
              calendarEvents,
              secFilings,
              recommendationTrend,
              upgradeDowngradeHistory,
              institutionOwnership,
              fundOwnership,
              majorDirectHolders,
              majorHoldersBreakdown,
              insiderTransactions,
              insiderHolders,
              netSharePurchaseActivity,
              earnings,
              earningsHistory,
              earningsTrend,
              industryTrend,
              indexTrend,
              sectorTrend,
            ],
          };
          let PastMonth = res.data[2].chart;
          let historicData = res.data[1].chart;
          var totalData = [data, historicData, PastMonth];
          console.log(totalData);
          return dispatch({
            type: FETCHING_DATA_SUCCESS,
            payload: totalData,
          });
        }
      })
      .catch((errors) => {
        console.error(errors);
      });
  };
};

export const fetchSingleCrypto = (sym) => {
  var dataURL = build_FinanceSingleURL(sym);
  var historicURL = build_HistoricSingleURL(sym);
  var data = {
    dataURL: `${dataURL}`,
    historicURL: `${historicURL}`,
  };
  return function (dispatch) {
    axios
      // .post("http://localhost:3005/api/stock/", data)
      .post("https://trend-backend.herokuapp.com/api/cryptos/", data)
      .then((res) => {
        if (res.data.name == "Error") {
          console.log(res.data.message, " - Cannot locate stock data");
        } else {
        }
      })
      .catch((errors) => {
        console.error(errors);
      });
  };
};
